enum ClientId {
  DEFAULT = 'default',
  GIVEAWAY_UI = 'giveaway_ui',
  GUIDE_TO_EV_UI = 'guide_to_ev_ui',
  HOME_UI = 'home_ui',
  SEM_UI = 'sem_ui',
  SRP_UI = 'srp_ui',
  USED_EV_TAX_CREDIT_UI = 'used_ev_tax_credit_ui',
  VDP_UI = 'vdp_ui',
  WHAT_TO_EXPECT_UI = 'what_to_expect_ui'
}

export default ClientId;
